import React from "react";
import { Controller } from "react-hook-form";
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from "@mui/x-date-pickers";
import { MobileTimePicker } from "@mui/x-date-pickers";
import 'dayjs/locale/en-in';
import { useState } from "react";
import { TextField } from "@mui/material";


const TimePick = ({
    label,
    variant,
    disabled,
    defaultValue,
    placeholder,
    InputProps,
    size,
    fullWidth,
    color,
    helperText,
    children,
    select,
    width,
    multiline,
    control,
    name,
    height,
}) => {
    const [reqTime, setreqTime] = useState(new Date());

    return (

        <Controller
            name={name}
            control={control}
            render={
                ({ field: { onChange, ...restField } }) => (
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-in">
                        {/* <DatePicker slotProps={{ textField: { size: 'small' } }}
                            label={label}
                            onChange={(event) => { onChange(event); setreqTime(event); }}
                            sx={{ width: width ? width : "16.625vw" }}
                            renderInput={(params) =>
                                <TextField size="small" {...params}
                                />}
                        /> */}
                        <DemoContainer
                            components={[
                                'MobileTimePicker',
                            ]}
                        >
                            <DemoItem>
                                <MobileTimePicker 
                                slotProps={{textField: {size: 'small'}}}
                                label={label}
                                onChange={(event) => {onChange(event); setreqTime(event)}}
                                sx={{width: width ? width : '18.25vw'}}
                                renderInput={(params) => 
                                    <TextField size="small" {...params} />
                                }                                
                                />
                            </DemoItem>

                        </DemoContainer>
                    </LocalizationProvider>
                )}
        />
    );
};

export default TimePick;